import React from "react";
import { DismissalButtonCopyVariant } from "../../../../../../common/service/server/dto/CMPSettingsDto";
import { ConsentSettingRow } from "../../../consentBanner/ConsentSettingRow";
import { ConsentOptionCards } from "../../../consentBanner/ConsentOptionCards";
import { BannerButtonPreview } from "../../../consentBanner/ConsentThumbnails";

export const ConsentBannerDismissButtonTextRow = () => {
  return (
    <ConsentSettingRow
      title="Close button"
      helpText="Closes the Manage Preferences screen. Choices save as soon as visitors toggle them, whatever this button says."
    >
      <ConsentOptionCards
        field="bannerDismissalButtonCopyVariant"
        ariaLabel="Preferences screen close button"
        layout="row"
        options={[
          {
            value: DismissalButtonCopyVariant.DEFAULT,
            label: "Done",
            note: "Default",
            preview: <BannerButtonPreview>Done</BannerButtonPreview>,
          },
          {
            value: DismissalButtonCopyVariant.CLOSE,
            label: "Close",
            preview: <BannerButtonPreview>Close</BannerButtonPreview>,
          },
        ]}
      />
    </ConsentSettingRow>
  );
};
